function mhProducts(){
  function normalizeText(str) {
    return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
}

// Normalizuj klíče
for (const key in categoryStockLimit) {
    categoryStockLimit[normalizeText(key)] = categoryStockLimit[key];
}

// Zjisti kategorii


if($('.type-detail').length){
    let categoryPathRaw = getShoptetDataLayer('product').defaultCategory;
    var categoryPath = Array.isArray(categoryPathRaw) ? categoryPathRaw : [categoryPathRaw];;
    var limit = categoryStockDefaultLimit
    for (const name of categoryPath) {
    const normalizedName = normalizeText(name);
    for (const key in categoryStockLimit) {
        const normalizedKey = normalizeText(key);
        if (normalizedName.startsWith(normalizedKey)) {
            limit = categoryStockLimit[key]; // použij nenermalizovaný klíč pro správnou hodnotu
            break;
        }
    }
    if (limit !== categoryStockDefaultLimit) break;
}
}
else if($('.product').length){
    limit = 5;
    if(typeof getShoptetDataLayer('category') !== 'undefined'){
    let categoryPathRaw = getShoptetDataLayer('category').path;
        var categoryPath = Array.isArray(categoryPathRaw) ? categoryPathRaw : [categoryPathRaw];
        for (const name of categoryPath) {
        const normalizedName = normalizeText(name);
        for (const key in categoryStockLimit) {
            const normalizedKey = normalizeText(key);
            if (normalizedName.startsWith(normalizedKey)) {
                limit = categoryStockLimit[key]; // použij nenermalizovaný klíč pro správnou hodnotu
                break;
            }
        }
        if (limit !== categoryStockDefaultLimit) break;
    }
    }
    
}

if($('.type-detail').length){
    const text = $('.p-info-wrapper .availability-amount').text().replace(/\s+/g, '').replace(/[^\d]/g, '');
    const qty = parseInt(text, 10);
    if (!isNaN(qty)) {
        if (qty > limit) {
            $('.p-info-wrapper .availability-amount').text(`(> ${limit} ks)`);
        } else {
        }
    }                
    
}

    if($('.products:not(#productsTop)').length){
        $('.products:not(#productsTop) .product').each(function(){
           
            var $product = $(this)
            var $quantity = `<span class="quantity">
                    <span class="increase-tooltip js-increase-tooltip" data-trigger="manual" data-container="body" data-original-title="${tooltipMin}" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
                    <span class="decrease-tooltip js-decrease-tooltip" data-trigger="manual" data-container="body" data-original-title="${toolltipMax}" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
                    <label>
                        <input type="number" name="amount" value="1" class="amount" autocomplete="off" data-decimals="0" step="1" min="1" max="9999" aria-label="Množství" data-testid="cartAmount">
                    </label>
                    <button class="increase" type="button" aria-label="Zvýšit množství o 1" data-testid="increase">
                        <span class="increase__sign">+</span>
                    </button>
                    <button class="decrease" type="button" aria-label="Snížit množství o 1" data-testid="decrease">
                        <span class="decrease__sign">−</span>
                    </button>
                </span>
                `; 
            if($(this).find('.p-tools form').length){
                $(this).find('.p-tools form').prepend($quantity)
            }
            const $avail = $product.find('.availability-amount');
            if ($avail.length) {
                const text = $avail.text().replace(/\s+/g, '').replace(/[^\d]/g, '');
                const qty = parseInt(text, 10);

                if (!isNaN(qty)) {
                    if (qty > limit) {
                        $avail.text(`(> ${limit} ks)`);
                    } else {
                    }
                }
            }
            $product.find('.price-additional').each(function () {
                const html = $(this).html();
                console.log(html)
                const updated = html.replace(bezDPH, '<small>'+bezDPH+'</small>');
                $(this).html(updated);
            });
           
        })

        
        
    }
}

$(document).ready(function() {
    mhProducts()
  })
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mhProducts()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    mhReplace();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    mhProducts();
});